import { CheckoutState } from '../../state';
import { isExpressApplePayEnabled } from '../applePay';
import { isExpressGooglePayEnabled } from '../googlePay';
import { isExpressPaypalEnabled } from '../paypal';

export const isExpressCheckoutEnabled = (state: CheckoutState) =>
    isExpressApplePayEnabled(state) ||
    isExpressPaypalEnabled(state) ||
    isExpressGooglePayEnabled(state);
